<template>
  <div>
    <h1>Reports</h1>
  </div>
</template>

<script>
//import ... from '@/components/...'
export default {
  name: "NewComponent",
  components: {},
  props: [],
  data() {
    return {
      //
    }
  },
  computed: {},
  created: function() {},
  mounted: function() {},
  updated: function() {},
  destroyed: function() {},
  methods: {}
}
</script>

<style lang="sass" scoped></style>
